module.exports = __webpack_public_path__ + "b326528d8d1f9c76ae82095561c3e29d.svg";